export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden bg-background-50 pt-20">
      {/* Decorative shapes - matching source site exactly */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {/* Dotted circle top right */}
        <svg className="absolute top-16 right-10 md:right-24 w-28 h-28 md:w-36 md:h-36 opacity-25" viewBox="0 0 140 140">
          <circle cx="70" cy="70" r="60" fill="none" stroke="#7c3aed" strokeWidth="1.5" strokeDasharray="5 7" />
        </svg>
        {/* Small dotted circle mid right */}
        <svg className="absolute top-40 right-1/3 w-12 h-12 opacity-20" viewBox="0 0 60 60">
          <circle cx="30" cy="30" r="24" fill="none" stroke="#1bb0ce" strokeWidth="2" strokeDasharray="4 5" />
        </svg>
        {/* Curved path bottom left */}
        <svg className="absolute bottom-24 left-4 md:left-16 w-24 h-24 opacity-15" viewBox="0 0 100 100">
          <path d="M10,85 C25,40 55,60 90,15" fill="none" stroke="#c74461" strokeWidth="2.5" strokeLinecap="round"/>
        </svg>
        {/* Triangle mid left */}
        <svg className="absolute top-48 left-1/4 w-8 h-8 opacity-20" viewBox="0 0 80 80">
          <polygon points="40,8 72,68 8,68" fill="none" stroke="#7c3aed" strokeWidth="2"/>
        </svg>
        {/* Small dots bottom right */}
        <svg className="absolute bottom-16 right-20 md:right-36 w-14 h-14 opacity-30" viewBox="0 0 70 70">
          <circle cx="10" cy="10" r="3.5" fill="#c74461"/>
          <circle cx="30" cy="6" r="2.5" fill="#c74461"/>
          <circle cx="52" cy="14" r="3" fill="#c74461"/>
          <circle cx="14" cy="30" r="2.5" fill="#c74461"/>
          <circle cx="36" cy="36" r="3.5" fill="#c74461"/>
          <circle cx="58" cy="28" r="2" fill="#c74461"/>
          <circle cx="22" cy="52" r="3" fill="#c74461"/>
          <circle cx="48" cy="56" r="2.5" fill="#c74461"/>
        </svg>
        {/* Ellipse near image area */}
        <svg className="absolute top-32 right-[38%] w-10 h-10 opacity-15" viewBox="0 0 60 40">
          <ellipse cx="30" cy="20" rx="28" ry="18" fill="none" stroke="#1bb0ce" strokeWidth="2"/>
        </svg>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-20 pt-10 md:pt-14 pb-0">
        <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-4 max-w-7xl mx-auto">
          {/* Left Text */}
          <div className="w-full lg:w-[44%] space-y-5 pb-8 lg:pb-16">
            <p className="text-[11px] font-semibold tracking-[0.35em] text-foreground-400 uppercase">
              OUR SERVICE
            </p>
            <h1 className="text-[2rem] md:text-[2.4rem] lg:text-[2.75rem] font-extrabold text-foreground-900 leading-[1.12]">
              We pledge ourselves to impeccable{" "}
              <span className="text-accent-500">moving.</span>
            </h1>
            <p className="text-[0.9rem] text-foreground-500 max-w-[360px] leading-relaxed">
              NW Trucking of NC is the best local trucking company
              you can turn to when it comes to your relocation.
            </p>
            <div className="pt-1">
              <a
                href="/local-moving"
                className="inline-block px-8 py-2.5 bg-accent-500 text-white font-semibold text-sm rounded-full hover:bg-accent-600 transition-colors whitespace-nowrap"
              >
                Read More
              </a>
            </div>
          </div>
                  <div className="w-full lg:w-[48%] relative">
                      {/* decorative elements */}
                      <svg className="absolute -top-4 -left-4 w-16 h-16 opacity-20 pointer-events-none" viewBox="0 0 80 80">
                          <circle cx="40" cy="40" r="34" fill="none" stroke="#7c3aed" strokeWidth="2" strokeDasharray="5 6" />
                      </svg>
                      <svg className="absolute bottom-4 -right-4 w-12 h-12 opacity-15 pointer-events-none" viewBox="0 0 60 60">
                          <polygon points="30,6 54,50 6,50" fill="none" stroke="#c74461" strokeWidth="2" />
                      </svg>
                      <svg className="absolute top-1/2 -right-6 w-10 h-10 opacity-15 pointer-events-none" viewBox="0 0 60 60">
                          <path d="M8,50 Q20,20 40,35 T52,8" fill="none" stroke="#1bb0ce" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                      <img
                          src="/images/h3.jpg"
                          alt="NW Trucking of NC team"
                          className="w-full h-auto rounded-xl object-cover"
                          width={900}
                          height={506}
                      />
                  </div>
          
          
        </div>
      </div>
    </section>
  );
}